module.exports = __webpack_public_path__ + "img/IBERDROLA_120X35.a2065e35.png";